export default __webpack_public_path__ + "static/media/main_banner2.27da9dc7.png";